import React, { useState } from 'react'
import { DatePicker } from 'antd-mobile'
import { getYear } from 'date-fns'
import './index.scss'
const YearPick = (props) => {
  const { yearSelect, year } = props
  const [yearSelectShow, setyearSelectShow] = useState(false)
  return (
    <div className="year-selecter">
      <div onClick={() => {
        setyearSelectShow(true)
      }}>
        <span>{year}年</span>
        <span className="yearselect-icon"></span>
      </div>
      <DatePicker
          max={new Date('2100/12/31')}
          min={new Date('2000/1/1')}
          onClose={() => {
          setyearSelectShow(false)
        }}
          onConfirm={(date) => {
          const year = getYear(date)
          console.log(year, '年')
          yearSelect(year)

        }}
          precision="year"
          renderLabel={(type, number) => {
          return <span>{`${number}年`}</span>
        }}
          title="时间选择"
          visible={yearSelectShow}
      />
    </div>
  )
}

export default YearPick